import { atom } from 'jotai'
import * as R from 'remeda'

import { brandGroupIdAtom } from '~/atoms'
import { type GroupFilter } from '~/gql/graphql'
import { compareGroup, exists, type Group, toNineNumber } from '~/utils'

import { groupInfosAtom } from './stateAtoms'

export const groupFiltersAtom = atom<GroupFilter[]>((get) => {
  const brandGroupId = get(brandGroupIdAtom)
  const groupInfos = get(groupInfosAtom)

  if (!exists(brandGroupId)) {
    return []
  }

  return R.pipe(
    groupInfos,
    R.groupBy(R.prop('group')),
    R.entries(),
    R.map(([group, groupInfos]) => ({
      group,
      filters: groupInfos.map((groupInfo) => ({
        brand_group_id: brandGroupId,
        brand_number: groupInfo.brandNumber,
        segment_number: toNineNumber(groupInfo.nineSegment),
      })),
    })),
    R.sort((a, b) => compareGroup(a.group as Group, b.group as Group)),
  )
})
